import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IDivisionState {
  level?: string
  division?: string
  template?: any
  permission?: any
}

namespace DivisionRedux {
  export const actionTypes = {
    SetNameDivision: '[SetNameDivision] Action',
    SetLevelDivision: '[SetLevelDivision] Action',
    SetTemplateDivision: '[SetTemplateDivision] Action',
    SetPermissionDivision: '[SetPermissionDivision] Action',
    SetClearDivision: '[SetClearDivision] Action',
  }

  export const initialDivisionState: IDivisionState = {
    level: '',
    division: '',
    template: '',
    permission: '',
  }

  export const reducer = () =>
    persistReducer<IDivisionState, ActionWithPayload<IDivisionState>>(
      {
        storage,
        key: 'DIVISION-FORM',
        whitelist: ['level', 'division', 'template', 'permission'],
      },
      (state: IDivisionState = initialDivisionState, action = {type: ''}) => {
        switch (action.type) {
          case actionTypes.SetLevelDivision: {
            const level = action.payload?.level

            return {...state, level}
          }

          case actionTypes.SetNameDivision: {
            const division = action.payload?.division

            return {...state, division}
          }

          case actionTypes.SetTemplateDivision: {
            const template = action.payload?.template

            return {...state, template}
          }

          case actionTypes.SetPermissionDivision: {
            const permission = action.payload?.permission

            return {...state, permission}
          }

          case actionTypes.SetClearDivision: {
            return initialDivisionState
          }

          default:
            return state
        }
      }
    )

  export const actions = {
    setLevelDivision: (data: IDivisionState) => ({
      type: actionTypes.SetLevelDivision,
      payload: data,
    }),
    setNameDivision: (data: IDivisionState) => ({
      type: actionTypes.SetNameDivision,
      payload: data,
    }),
    setTemplateDivision: (data: IDivisionState) => ({
      type: actionTypes.SetTemplateDivision,
      payload: data,
    }),
    setPermissionDivision: (data: IDivisionState) => ({
      type: actionTypes.SetPermissionDivision,
      payload: data,
    }),
    setClearDivision: () => ({
      type: actionTypes.SetClearDivision,
    }),
  }
}

export default DivisionRedux
